<template>
  <!-- Popup Deposit -->
  <el-dialog :title="$t('TEXT_SUCCESS')" :visible.sync="isShowRemove2FASuccess" class="deposit-form">
    <div class="popup-inner">
      <div class="item icon-wrapper">
        <i class="el-icon-circle-check"></i>
      </div>
      <div class="item">
        <div class="text-break-word bold">{{ $t('TEXT_SUCCESS') }}</div>
        <p>{{ $t('TEXT_REMOVE_2FA_SUCCESS') }}
        </p>
      </div>
      <div class="item item-submit">
        <a class="btn btn-submit" @click="login">{{ $t('BTN_LOGIN') }}</a>
      </div>
    </div>
  </el-dialog>
  <!-- End Popup Deposit -->
</template>

<script>
export default {
  computed: {
    isShowRemove2FASuccess: {
      get () {
        return this.$store.getters.isShowRemove2FASuccess
      },
      set () {
        this.$store.dispatch('toggleRemove2FASuccessForm')
      }
    },
    modalData () {
      return this.$store.getters.modalData
    }
  },
  methods: {
    login () {
      this.$store.dispatch('closeAllModal')
      setTimeout(() => {
        this.$store.dispatch('toggleLoginFormModal')
      }, 0)
    }
  }
}
</script>
